module.exports = __webpack_public_path__ + "static/img/guzhan.725380b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/guzhan.jpg
// module id = WwI3
// module chunks = 6